class Mwwpform {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const confirmHideElement = '.confirm-hide';
    $(confirmHideElement).hide();
  }
}
